module.exports = __webpack_public_path__ + "img/grid-right-small.5877fb33.svg";